.flash-banner-cta-container {
    /* This makes sure the link won't wrap to another line */
    width: 126px;
    display: flex;
    align-items: center;
}
